import { LabelInput } from '@/components/creator/LabelInput';

/**
 * LabelsSection Component
 *
 * Tags/labels input with autocomplete
 */

interface LabelsSectionProps {
  labels: string[];
  onChange: (labels: string[]) => void;
  disabled: boolean;
}

export const LabelsSection = ({
  labels,
  onChange,
  disabled,
}: LabelsSectionProps) => {
  return (
    <div>
      <LabelInput
        labels={labels}
        onChange={onChange}
        disabled={disabled}
      />
    </div>
  );
};
